window.addEventListener("load", ()=>{ 
    let membershipCheckbox = document.getElementById('cherryClub');
    let newsletterCheckbox = document.getElementById('newsletter');
    let btn = document.querySelector('.customer-register .form-field__register-submit');

    function checkboxCheck(){
        if (membershipCheckbox.checked) {
            if(!newsletterCheckbox.checked) {
                if(btn) {
                    btn.disabled = true;
                }
                membershipCheckbox.value = "";
            } else {
                if(btn) {
                    btn.disabled = false;
                }
                membershipCheckbox.value = "customer_club";
            }            
        } else {
            if(btn) {
                btn.disabled = false;
            }
            membershipCheckbox.value = "";
        }
    }

    if(membershipCheckbox && newsletterCheckbox) {

        membershipCheckbox.addEventListener('change', function() {
            checkboxCheck();
        });

        newsletterCheckbox.addEventListener('change', function() {
            checkboxCheck();
        });

    }
    
});
